<template>
  <form action="#">
    <van-search :background="backColor" :value="value" :placeholder="placeholder" show-action clearable shape="round" @input="$emit('input', $event)" @search="onSearch" @clear="onClear">
      <div slot="action" class="f14" :class="[actionColor]" @click.prevent.stop="onSearch" v-if="action">搜索</div>
      <div slot="action" class="f14" :class="[actionColor]" @click.prevent.stop="onCancel" v-else>取消</div>
    </van-search>
  </form>
</template>
<script>
export default {
  name: 'search-bar',
  components: {},
  data() {
    return {};
  },
  model: {
    prop: 'value',
    event: 'input'
  },
  props: {
    value: String,
    actionColor: {
      type: String,
      default: 'c-white'
    },
    placeholder: {
      type: String,
      default() {
        return '搜索关键字';
      }
    },
    backColor: {
      type: String,
      default() {
        return '';
      }
    },
    action: {
      type: Boolean,
      default: false
    }
  },
  computed: {
  },
  created() {},
  mounted() {},
  watch: {},
  methods: {
    onSearch() {
      this.$emit('search');
    },
    onCancel() {
      this.$emit('input', '');
      this.$emit('clear');
    },
    onClear() {
      this.$emit('clear');
    }
  }
};
</script>
<style lang="less" scoped>
</style>
